import { StackView, Button } from '@planningcenter/tapestry-react';
import React from 'react';
import { useChatContext } from 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../_virtual/moment.js';
import colors from '../../vendor/topbar/colors.js';
import { useChat } from '../../hooks/use_chat.js';
import '../../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { DrawerHeading } from '../../vendor/topbar/components/drawer_heading.js';
import { ScrollContainer } from '../../vendor/topbar/components/scroll_container.js';
import { Groups } from './groups.js';
import { useChatGroups } from './hooks/use_chat_groups.js';
import { useChatMemberAbility } from './hooks/use_chat_member_ability.js';
import { People } from './people.js';
import { Settings } from './settings.js';
import { Title } from './title.js';

const Details = ({ channel }) => {
    const chatGroups = useChatGroups(channel);
    const chatMemberAbility = useChatMemberAbility(channel);
    return (React.createElement(ScrollContainer, null,
        React.createElement(StackView, { padding: 2, spacing: 4, grow: 1, distribution: "start" },
            React.createElement(Title, { channel: channel, isEditable: chatMemberAbility.canUpdate }),
            React.createElement(Settings, { channel: channel, isRemovable: chatMemberAbility.canDelete }),
            Object.keys(chatGroups).length > 0 && React.createElement(Groups, { groups: chatGroups }),
            React.createElement(People, { channel: channel }))));
};
const ChannelDetailsView = () => {
    const { channel } = useChatContext();
    const { navigation } = useChat();
    if (!(channel && navigation.isChannelDetailsViewActive))
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1, padding: 2, paddingTop: 1 },
            React.createElement(Button, { "aria-label": "Switch to chat list", color: colors.lightNeutral12, icon: "general.leftChevron", onClick: () => navigation.switchToChannelView(channel.id), size: "sm", title: "Back to chat list", variant: "naked" }),
            React.createElement(DrawerHeading, { truncate: true }, "Conversation details")),
        React.createElement(Details, { channel: channel })));
};

export { ChannelDetailsView };
//# sourceMappingURL=index.js.map
